import { Reducer } from 'interfaces'
import { AdvisorDataState } from 'components/features/coaching/advisorStore/interfaces/state'
import { createFetchableReducer, createEmptyFetchable } from 'helpers/loadableHelpers'
import { CREATE_ADVISOR_MEETING, ResetCreateMeetingAction } from 'components/features/coaching/advisorStore/actions/advisorMeetingActions'
import { KILL_ALL_FLOATING_PANES, KILL_FLOATING_PANES } from 'actions/floatingPanesActions'


const fetchableRequestReducer = createFetchableReducer<null>()
export const createMeetingReducer: Reducer<AdvisorDataState['createMeetingRequest']> = (prevState = createEmptyFetchable(), action) => {
  switch (action.type) {
    case CREATE_ADVISOR_MEETING:
      return fetchableRequestReducer(prevState, action)

    case KILL_ALL_FLOATING_PANES:
    case KILL_FLOATING_PANES:
    case ResetCreateMeetingAction.type:
      return createEmptyFetchable()
  }
  return prevState
}
